import React from 'react';
import styled from 'styled-components';
import { trackClick } from '../utils/analytics';

const SMART_LINK = 'https://bnds.us/5na464';

const Container = styled.div`
  max-width: 900px;
  margin: 2rem auto 3rem;
  padding: 1.5rem;
  background: rgba(26, 26, 26, 0.6);
  border: 2px solid rgba(0, 247, 255, 0.25);
  border-radius: 12px;
  box-shadow: 0 0 20px rgba(0, 247, 255, 0.08);
`;

const FollowButton = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.8rem;
  padding: 1rem 1.5rem;
  background: rgba(26, 26, 26, 0.8);
  border: 2px solid rgba(0, 247, 255, 0.4);
  border-radius: 8px;
  color: #00f7ff;
  text-decoration: none;
  font-family: 'Share Tech Mono', monospace;
  font-size: 1rem;
  letter-spacing: 2px;
  text-transform: uppercase;
  transition: all 0.3s ease;

  &:hover {
    background: rgba(0, 247, 255, 0.1);
    border-color: #00f7ff;
    transform: translateY(-3px);
    box-shadow: 0 5px 20px rgba(0, 247, 255, 0.3);
  }
`;

const Caption = styled.p`
  margin: 0.75rem 0 0;
  text-align: center;
  color: rgba(255, 255, 255, 0.6);
  font-family: 'Share Tech Mono', monospace;
  font-size: 0.8rem;
  letter-spacing: 1px;
`;

const BandsintownWidget: React.FC = () => {
  const handleClick = () => {
    trackClick('bandsintown_follow', { url: SMART_LINK });
  };

  return (
    <Container>
      <FollowButton
        href={SMART_LINK}
        target="_blank"
        rel="noopener noreferrer"
        onClick={handleClick}
      >
        Follow on Bandsintown →
      </FollowButton>
      <Caption>Get notified when I tour near you</Caption>
    </Container>
  );
};

export default BandsintownWidget;
